import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Spinner from '@components/spinner'
import PropTypes from 'prop-types'

class UploadFile extends Component {
  onChange = e => {
    if (e.target.files.length < 1) return null

    const file = e.target.files[0]

    if (this.props.preUpload) {
      this.props
        .preUpload()
        .then(res => {
          if (!(res && res.includes('undefined'))) {
            this.props.uploadStore.upload({
              file,
              url: res ? res : this.props.url,
              onOk: res => {
                this.props.growlStore.showSuccess(
                  'You have successfully uploaded an attachment.'
                )

                return this.props.onOk(res)
              },
              onError: this.props.onError
            })
          }
        })
        .catch(error => {
          throw new Error(error.message)
        })

      return
    }

    this.props.uploadStore.upload({
      file: e.target.files[0],
      url: this.props.url,
      onOk: res => {
        this.props.growlStore.showSuccess(
          'You have successfully uploaded an attachment.'
        )

        return this.props.onOk(res)
      },
      onError: this.props.onError
    })
  }

  render () {
    return (
      <div className="upload-wrapper">
        <input
          className="display-none"
          ref="attachment"
          type="file"
          onChange={this.onChange}
        />
        <button
          type="button"
          onClick={() => this.refs.attachment.click()}
          className="button button-medium button--secondary">
          {this.props.label || 'Upload'}
        </button>
        {this.props.uploadStore.loading ? <Spinner inline /> : null}
      </div>
    )
  }
}

UploadFile.propTypes = {
  onOk: PropTypes.func,
  onError: PropTypes.func,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  uploadStore: PropTypes.object,
  growlStore: PropTypes.object
}

export default inject(
  'uploadStore',
  'growlStore',
  'expertStore'
)(observer(UploadFile))
